import { ColorPickerProps } from '../components/color-picker-v3/src/props';

export function useInitColorPicker(props: ColorPickerProps) {
  let pureColor = '#ffffff';
  let gradientColor = 'linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(0, 0, 0, 1) 100%)';

  let last = '';

  // modelValue为空时，默认显示传过来的默认颜色
  if (!props.modelValue) {
    pureColor = props.defPureColor;
  } else {
    if (props.modelValue?.indexOf('linear-gradient') > -1) {
      gradientColor = props.modelValue;
      last = gradientColor;
    } else {
      pureColor = props.modelValue;
      last = pureColor;
    }
  }

  return {
    pureColor,
    gradientColor,
    last,
  };
}
